'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var changeVersToCompare = function () {
  var model = void 0,
      newId = void 0;
  var zero = $('<option/>').text('-- Selecciona');

  var _setModel = function _setModel(value) {
    return model = value;
  };
  // const _getModel = () => model

  var _setNewId = function _setNewId(value) {
    return newId = value;
  };
  var _getNewId = function _getNewId() {
    return newId;
  };

  var selectorsContainerClass = '.js-select-container';

  var selectorsByCategory = {
    motores: '.js-comp-motors',
    transmisiones: '.js-comp-transmissions',
    tracciones: '.js-comp-tractions',
    grados: '.js-comp-versions'
  };

  var selectorsOrdered = void 0;

  var _openDialog = function _openDialog(lcv) {
    if (lcv) {
      selectorsByCategory.carrocerias = '.js-comp-carbodys';
      selectorsByCategory.carrozados = '.js-comp-carbodys-2';
      selectorsByCategory.configuraciones = '.js-comp-configs';
      selectorsByCategory.mmas = '.js-comp-mmas';
      var extraSelects = [];
      selectorsOrdered = selectorsOrdered = ['.js-comp-carbodys', '.js-comp-carbodys-2', '.js-comp-configs', '.js-comp-motors', '.js-comp-transmissions', '.js-comp-tractions', '.js-comp-mmas', '.js-comp-versions'];
    } else {
      selectorsOrdered = ['.js-comp-motors', '.js-comp-transmissions', '.js-comp-tractions', '.js-comp-versions'];
    }

    _loadJson(lcv);

    $(selectorsContainerClass).removeClass('fadeOut');

    $('.js-to-hide').slideUp(600, function () {
      $('.js-to-show').slideDown(400);
    });

    $('.js-close-change-dialog').off('click').on('click', function () {
      _closeDialog();
    });
  };

  var _closeDialog = function _closeDialog() {
    $('.js-to-show').slideUp(600, function () {
      $('.js-to-hide').slideDown();
    });
  };

  var _loadJson = function _loadJson(lcv) {
    var model = compareEquip.getModel();
    var moi = compareEquip.getMOI();
    _setModel(model);

    var jsonData = void 0;

    $.getJSON(globalEnv + 'servicios/getjsoncombinacionescomparador?modelo=' + model + '&moi=' + moi + '&mercado=ES&lcv=' + lcv, function (data) {
      return jsonData = data;
    }).done(function () {
      _makeSelect(selectorsOrdered[0], jsonData);
      _addBtnAction();
    });
  };

  var _resetSelectors = function _resetSelectors(elem) {
    // * Empty the current selector element, append initial option to it and enable it
    $(elem).empty().append(zero).removeAttr('disabled');
    // * Empty the following selectors, disable them and remove "notice-option" class if needed
    var index = selectorsOrdered.indexOf(elem);
    for (var i = index + 1; i < selectorsOrdered.length; i++) {
      $(selectorsOrdered[i]).empty().attr('disabled', 'disabled').removeClass('notice-option');
    }
    // * Show the hidden container of current selector
    $(selectorsOrdered[index]).parents(selectorsContainerClass).removeClass('fadeOut');
    // * Disable button
    $('.js-comp-btn').attr('disabled', 'disabled');
  };

  var _noticeOption = function _noticeOption(elem, str) {
    $(elem).empty().addClass('notice-option');
    var opt = $('<option />').text(str).val('');
    return opt;
  };

  var _makeSelect = function _makeSelect(elem, array) {
    var currentVersions = compareEquip.getTotalVersions();
    var nextArrayName = void 0;
    // * Reset the selectors from the current one onwards
    _resetSelectors(elem);
    // * Iterate the JSON array of selectors for building its options
    for (var i = 0; array[i]; i++) {
      var arrItem = array[i];
      var skip = false;
      for (var prop in arrItem) {
        // * If the property value is a string then it must be the text of the select option
        if (typeof arrItem[prop] === 'string') {
          // * If the current property value is empty (NO) hide it and skip this selector
          if (arrItem[prop] === 'NO') {
            $(elem).parents(selectorsContainerClass).addClass('fadeOut');
            skip = true;
            break;
          }
          var opt = void 0;
          // * Only append the value of property "grado" (version) to the text of an option if it isn't one of the current versions in slider
          if (prop !== 'id' && currentVersions.indexOf(arrItem.id) === -1) {
            opt = $('<option/>').text(arrItem[prop]).val(i);
          } else {
            // !!! The only version is already in the slider. So, disable the option and replace the value with a notice
            if (array.length === 1 && prop !== 'id') {
              console.log('The only version is one of the current versions', '\n', zero, '\n', array, '\n', arrItem[prop]);
              /* $(elem).empty().css('color', '#999');
              opt = $('<option/>').text().val('') */
              opt = _noticeOption(elem, arrItem[prop] + ' - Esta versi\xF3n ya est\xE1 entre las comparadas');
            }
          }

          // * If property is "grado" the select option must have a value with the version id
          if (prop === 'grado' && typeof opt !== 'undefined') {
            opt.val(arrItem.id);
            nextArrayName = 'end';
          }
          // * Adding the option to select element
          if (typeof opt !== 'undefined') {
            $(elem).append(opt);
          }
          // * Adding data attribute with the property name as value to the select element
          $(elem).attr('data-type', prop);
        }

        // * If the property value is an array then we determine that the next array is the property
        if (_typeof(arrItem[prop]) === 'object') {
          nextArrayName = prop;
        }
      }

      if (skip) {
        _makeSelect(selectorsByCategory[nextArrayName], array[0][nextArrayName]);
        return;
      }
    }

    // * If selector has only the "zero" option is because all versions are already in slider
    if ($(elem).children('option').length === 1 && $(elem).children('option').text() === zero.text()) {
      var _opt = _noticeOption(elem, 'Todas las versiones est\xE1n entre las comparadas');
      $(elem).append(_opt);
    }

    $(elem).off('change').on('change', function () {
      $(this).find('.js-zero-option').remove();
      if (nextArrayName !== 'end') {
        var nextArray = array[$(this).val()][nextArrayName];
        _makeSelect(selectorsByCategory[nextArrayName], array[$(this).val()][nextArrayName]);
      } else {
        _setNewId($(this).val());
        $('.js-comp-btn').removeAttr('disabled');
      }
    });
  };

  var _addBtnAction = function _addBtnAction() {
    $('.js-comp-btn').off('click').on('click', function () {
      var newValue = _getNewId();
      _closeDialog();
      compareEquip.reload(newValue);
    });
  };

  return {
    openDialog: _openDialog
  };
}();